import React from 'react';
import { useState, useEffect } from 'react';
import './reticles.scss';
import Tooltip from "../../tooltip/Tooltip";

export default function Reticles (props) {
    // constructor(props) {
        // super(props)
    const [reticleName, setReticleName] = useState('My Reticle');
    const [isRenamingActive, setIsRenamingActive] = useState(false);
    const [reticleNameErr, setReticleNameErr] = useState(false);
    const [reticleNameErrValue, setReticleNameErrValue] = useState('');

        // this.state = {
        //     reticleName: 'My Reticle',
        //     isRenamingActive: false,
        //     reticleNameErr: false,
        //     reticleNameErrValue: ''
        // }

    const handlerReticleNameChange = (e) => {
        const regex = new RegExp(/^[A-Za-z0-9 _.,|)("-]*$/);

        if (regex.test(e.target.value) !== true) {
            setReticleNameErr(true);
            setReticleNameErrValue(e.target.value);
            // this.setState({ reticleNameErr: true, reticleNameErrValue: e.target.value })

            setTimeout(() => {
                setReticleNameErr(false)
                // this.setState({ reticleNameErr: false })
            }, 5000);

        }
        if (reticleName !== e.target.value && regex.test(e.target.value) !== false) {
            console.log('e.target.value', e.target.value)
            setReticleName(e.target.value);
            setReticleNameErr(false);
        }

        // if (this.state.reticleName !== e.target.value && regex.test(e.target.value) !== false) {
        //     this.setState({ reticleName: this.state.reticleName = e.target.value })
        //     this.setState({ reticleNameErr: false })
        // }

        props.handlerReticleRename(e.target.value)
    };

    const handlerBlur = async (e) => {
        if (!e.target.value) {
            setReticleName('My Reticle');

            // this.setState({ reticleName: this.state.reticleName = 'My Reticle' })
        }
        await props.handlerReticleRename(reticleName)
        setIsRenamingActive(false);
        setReticleNameErr(false);

        // this.setState({
        //     isRenamingActive: false,
        //     reticleNameErr: false
        // })
        props.blur(props.activeTab.svg)
    }

    useEffect(() => {
        if (reticleName !== props?.activeTab?.name) {
            setReticleName(props?.activeTab?.name);
            // this.setState({
            //     reticleName: this.state.reticleName = props?.activeTab?.name
            // })
        }
    }, [reticleName, setReticleName, props.activeTab.name])


    // componentDidUpdate() {
    //     if (this.state.reticleName !== this.props?.activeTab?.name) {
    //         this.setState({
    //             reticleName: this.state.reticleName = this.props?.activeTab?.name
    //         })
    //     }
    //     // console.log('RETICLE', this.props.name)
    // }

        useEffect(() => {
            if (reticleName !== props?.activeTab?.name) {
                setReticleName(props?.activeTab?.name);

                // this.setState({
                //     reticleName: this.state.reticleName = props?.activeTab?.name
                // })
            }
        }, [])
    
    // componentDidMount() {

    //     if (this.state.reticleName !== this.props?.activeTab?.name) {
    //         this.setState({
    //             reticleName: this.state.reticleName = this.props?.activeTab?.name
    //         })
    //     }

    // }

    const reticleNameContent = () => {
        return (
            <p style={{ margin: 0 }}>Rename</p>
        )
    }

    const reticleButtonContent = () => {
        return (
            <p style={{ margin: 0 }}>{reticleName}</p>
        )
    }

    const handleActivateRenaming = () => {
        setIsRenamingActive(true);
        // this.setState({
        //     isRenamingActive: true
        // })
    }

    const handleSliceRenaming = () => {
        const name = reticleName
        if (name && name.length > 10) {
            return (name.slice(0, 10) + "...")
        } else return (name)
    }

        return (
            <section className='reticles_section'>

                {/*
                <select name='select' id='reticle_slct' className='select'>
                    <option value='my_reticle1'>Reticle 1</option>
                    <option value='my_reticle2'>Reticle 2</option>
                </select>
            */}
                {/* <div> */}
                {isRenamingActive ? (
                    <div style={{ width: '190px', backgroundColor: '#131318' }}>
                        <Tooltip
                            content={reticleNameContent()}
                            direction="bottom"
                        >
                            {/* <label htmlFor='RegisterName' className='reticles_name'>
                                Name: */}
                            <input type='text' className='reticles_section-input' value={reticleName} style={{ width: '170px', marginBottom: reticleNameErr ? 0 : 20 }}
                                placeholder='My Reticle'
                                onChange={handlerReticleNameChange}
                                onFocus={props.focus}
                                onBlur={handlerBlur}
                                autoFocus={true}
                                maxLength="50"
                            />
                            {reticleNameErr ? (
                                <p style={{ margin: 0, color: '#FF5050', fontSize: 12, marginLeft: 5 }}>Invalid character</p>
                            ) : null}

                            {/* </label> */}
                        </Tooltip>
                    </div>

                ) : (
                    <Tooltip
                        content={reticleButtonContent()}
                        direction="bottom"
                    >

                        <button className='reticles-btn-icon reticles-btn' onClick={handleActivateRenaming}
                        >Name: {handleSliceRenaming()}</button>
                    </Tooltip>

                )}
                {/* </div> */}

            </section>
        )
}
